import React from 'react';
import PropTypes from 'prop-types';

import { ChipsItem } from '@atlas/ui';

import { FAVORITE_MARKET_GROUPS } from 'common/constants';

const DetailsEventGroups = ({ activeGroup, marketGroups, setActiveGroup }) => (
  <div className="chips-list">
    {marketGroups?.map(({ text, value }) => {
      const isActive = activeGroup.group === value.group;
      const onClick = () => setActiveGroup(value);

      const id = crypto.randomUUID();

      if (value.group === FAVORITE_MARKET_GROUPS) {
        return <ChipsItem active={isActive} icon="star" key={id} onClick={onClick} />;
      }

      return <ChipsItem active={isActive} key={id} label={text} onClick={onClick} />;
    })}
  </div>
);

DetailsEventGroups.propTypes = {
  activeGroup: PropTypes.object.isRequired,
  marketGroups: PropTypes.arrayOf(PropTypes.object),
  setActiveGroup: PropTypes.func.isRequired,
};

export default DetailsEventGroups;
